module.exports = __webpack_public_path__ + "a17d279f/img/archive-icon.0a6a9de3.svg";